import { render } from "./AdminOpenApplication.vue?vue&type=template&id=0f0b0298"
import script from "./AdminOpenApplication.vue?vue&type=script&lang=js"
export * from "./AdminOpenApplication.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__